export function getPageUtmWebteam(path: string, position: 'header' | 'sticky' | 'slice'): string | null {
    if (/\/(?:products|platform)(?:\/|$)/.test(path)) return `product-${position}`;
    // The custom MSP page uses product attribution for its header, sticky menu and CTA slice.
    if (/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?msp\/?$/i.test(path)) return `product-${position}`;
    if (/\/solutions(?:\/|$)/.test(path)) return `solution-${position}`;
    if (!/\/compare-acronis(?:\/|$)/.test(path) || position === 'slice') return null;
    if (position === 'sticky') return 'compete-sticky';

    const match = path.match(/\/compare-acronis\/([^/?#]+)/);
    // Slugs look like "acronis-vs-veeam" but the taxonomy wants just the competitor.
    const competitor = match?.[1].replace(/^acronis-vs-/, '');
    return competitor ? `compete-header-${competitor}` : 'compete-header';
}

export function appendUtmWebteam(url: string, value: string, domain: string): string {
    if (!url || !value) return url;
    // In-page anchors (e.g. "#form") are left untouched: adding a query would turn the
    // click into a same-page navigation/reload instead of a scroll.
    if (url.startsWith('#')) return url;
    try {
        const base = `https://${domain}`;
        const parsed = new URL(url, base);
        if (!['http:', 'https:'].includes(parsed.protocol)) return url;
        if (parsed.searchParams.has('utm_webteam')) return url;
        parsed.searchParams.set('utm_webteam', value);
        const isAbsolute = url.startsWith('http://') || url.startsWith('https://') || url.startsWith('//');
        return isAbsolute ? parsed.toString() : `${parsed.pathname}${parsed.search}${parsed.hash}`;
    } catch {
        return url;
    }
}
